import { render } from "./S312867.vue?vue&type=template&id=32e1deec"
const script = {}
script.render = render

export default script